<template>
  <div class="main-content">
    <section class="section">
      <!-- Breadcrumb -->
      <PageHeaderNoAction>
       </PageHeaderNoAction>
      <div class="section-body">
        <DataFilter :gridId="gridId" :isExport="false" :hasNew="true" newLink="/Builder/FormBuilder/New"></DataFilter>
        <SlickGrid :gridId="gridId" :editable="false" :frozenColumn="2" :isAutoInitData="true" baseUrl="/userBuildForm"/>
      </div>
    </section>
  </div>
</template>


<script>
import api from "@/api";
import config from "@/config";
import { mapActions, mapGetters } from "vuex";
import helper from "@/vueHelper";

export default {
  title: "User Build Form List",
  access_code: "UBF_LIST01",
  icon: "far fa-copy fa-fw",
  components: {},
  order:6,
  data() {
    return {
      gridId: "list02",
      formData: {
        staff_name: ""
      }
    };
  },
  created() {
  },
  computed: {
    ...mapGetters("grid", ["getGridById"]),

    grid() {
      return _.cloneDeep(this.getGridById(this.gridId));
    },
    dataList() {
      return this.grid.selectRows || [];
    },
   
  },
  mounted() {},
  methods: {
    ...mapActions("grid", ["actionResetGrid", "actionSetGrid", "actionRequest"]),

  }
};
</script>

<style scoped>
.section-body{
  padding-top:100px
}
</style>